// extracted by mini-css-extract-plugin
export default {"modal":"DeleteCandidateGroupModal-module__modal__oDFBO","detail":"DeleteCandidateGroupModal-module__detail__+w3tg","content":"DeleteCandidateGroupModal-module__content__8XlqJ"};